export const redisConfig = {
    host:  process.env.BUILD_ENV === 'prod' ? 'redis-grounds-bus.mmt.mmt' : 'pp.redis.goibibo.dev',
    port: '6379',
    db: '8',
    ttl: 60 * 60 * 24 * 1, // 1 day
  }
  export const redirectRedisConfig = {
    host:  process.env.BUILD_ENV === 'prod' ? 'redis-grounds-bus.mmt.mmt' : 'pp.redis.goibibo.dev',
    port: '6379',
    db: '8',
    ttl: 60 * 60 * 1 * 1, // 1 hour
  }